// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import MembershipBusinessListModel from '../../model/membership-business-list-model';
import MembershipBusinessListDTO from '../dto/membership-business-list-dto';
import dtoSchema from '../schemas/membership-business-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class MembershipBusinessListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<MembershipBusinessListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.isActive = data.isActive;
      this.name = data.name ?? undefined;
      this.city = data.city ?? undefined;
      this.postalCode = data.postalCode ?? undefined;
      this.categoryName = data.categoryName ?? undefined;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  isActive?: boolean;
  /**
  */
  name?: string;
  /**
  */
  city?: string;
  /**
  */
  postalCode?: string;
  /**
  */
  categoryName?: string;

  static toModel(dto: DeepPartial<MembershipBusinessListDTO>): MembershipBusinessListModel;
  static toModel(dto: DeepPartial<MembershipBusinessListDTO> | undefined | null): MembershipBusinessListModel | undefined;
  static toModel(dto: DeepPartial<MembershipBusinessListDTO> | undefined | null): MembershipBusinessListModel | undefined {
    return dto ? new MembershipBusinessListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<MembershipBusinessListModel> | MembershipBusinessListModel): MembershipBusinessListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      isActive: unwrapped.isActive,
      name: unwrapped.name,
      city: unwrapped.city,
      postalCode: unwrapped.postalCode,
      categoryName: unwrapped.categoryName,
    } as MembershipBusinessListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for MembershipBusinessListModel, can not map to MembershipBusinessListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
